import List from './List';
import debounce from 'debounce';
/**
 * Handles filtering a VueTable by provided filter fields and values
 */
export default {
	mixins: [List],
	props: {
		filters: {
			type: Object,
			default: () => ({}),
		}
	},
	methods: {
		debounceReload() {},
		//Preserve filters in url when changing tabs, if filters aren't tab-specific
	},
	watch: {
		filters: {
			deep: true,
			handler() {
				this.debounceReload();
				//this.$router.replace({query: this.querystring});
			}
		}
	},
	created(){
		//Set this during component creation to avoid multiple components sharing the same debounce
		this.debounceReload = debounce(function() {
			this.$refs.vuetable.reload();
		}, 250);
	}
}
